'use strict';

import { types } from "../types/types";

const initialState = {
  rolesLoading: false,
  roles: [],
  poolLoading: false,
  pool: {
    roleKey: null,
    moduleName: null,
    rows: [],
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    searchText: "",
    pageSize: 10
  },
  assignedLoading: false,
  assigned: {
    roleKey: null,
    moduleName: null,
    rows: []
  },
  metricsLoading: false,
  metrics: {
    roleKey: null,
    totals: {
      overall: 0,
      pool: 0,
      assigned: 0,
      pending: 0,
      blocked: 0
    },
    modules: []
  },
  actionLoading: {
    assign: false,
    release: false
  },
  error: null
};

const normalizePoolPayload = (payload = {}) => {
  const poolData = payload.data || {};
  const rows = poolData.rows || poolData.records || [];
  return {
    roleKey: payload.roleKey,
    moduleName: payload.moduleName,
    rows,
    totalItems: poolData.totalItems ?? poolData.total ?? rows.length,
    totalPages: poolData.totalPages ?? poolData.pages ?? 0,
    currentPage: poolData.currentPage ?? poolData.page ?? payload.page ?? 0,
    searchText: payload.searchText || "",
    pageSize: payload.size ?? poolData.size ?? rows.length
  };
};

export const specialistSelectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SPECIALIST_SELECTION_SET_ROLES_LOADING:
      return {
        ...state,
        rolesLoading: action.payload
      };

    case types.SPECIALIST_SELECTION_SET_ROLES:
      return {
        ...state,
        roles: action.payload || []
      };

    case types.SPECIALIST_SELECTION_SET_POOL_LOADING:
      return {
        ...state,
        poolLoading: action.payload?.loading ?? true
      };

    case types.SPECIALIST_SELECTION_SET_POOL:
      return {
        ...state,
        pool: normalizePoolPayload(action.payload),
        poolLoading: false
      };

    case types.SPECIALIST_SELECTION_SET_ASSIGNED_LOADING:
      return {
        ...state,
        assignedLoading: action.payload?.loading ?? true
      };

    case types.SPECIALIST_SELECTION_SET_ASSIGNED:
      return {
        ...state,
        assigned: {
          roleKey: action.payload?.roleKey || null,
          moduleName: action.payload?.moduleName || null,
          rows: action.payload?.rows || []
        },
        assignedLoading: false
      };

    case types.SPECIALIST_SELECTION_SET_ACTION_LOADING: {
      const nextActionLoading = { ...state.actionLoading };
      if (action.payload?.action) {
        nextActionLoading[action.payload.action] = action.payload.status;
      }
      return {
        ...state,
        actionLoading: nextActionLoading
      };
    }

    case types.SPECIALIST_SELECTION_SET_METRICS_LOADING:
      return {
        ...state,
        metricsLoading: action.payload ?? true
      };

    case types.SPECIALIST_SELECTION_SET_METRICS:
      return {
        ...state,
        metrics: {
          roleKey: action.payload?.roleKey || null,
          totals: action.payload?.totals || initialState.metrics.totals,
          modules: action.payload?.modules || []
        },
        metricsLoading: false
      };

    case types.SPECIALIST_SELECTION_SET_ERROR:
      return {
        ...state,
        error: action.payload || null
      };

    default:
      return state;
  }
};


